import { createSlice } from '@reduxjs/toolkit'
import SharedCollectionReducer from './SharedCollectionReducer'
import { useSelector } from 'react-redux'

const initialState = {
    response: {}
}

const SharedCollection = createSlice({
    name: 'sharedCollections',
    initialState,
    reducers: SharedCollectionReducer
})

export const SharedCollectionActions = SharedCollection.actions

export const useSharedCollections = () =>
    useSelector((state) => state.sharedCollections.response)
export const useCollectionResponseList = () =>
    useSelector((state) => state.sharedCollections.collectionResponse)

export default SharedCollection.reducer
